import { hasAvatar } from './HelperFunctions';

export const getProfileCompletion = (user) => {
  if (!user) {
    return {
      nameCompleted: false,
      avatarCompleted: false,
      locationCompleted: false,
      sectorCompleted: false,
      profileStepsCompleted: 0,
      profileStepsTotal: 0,
      profileCompletionPercentage: 0,
      isProfileComplete: false,
    };
  }

  const rawDisplayName = user.displayname || '';
  const trimmedDisplayName = rawDisplayName.trim();
  const nameCompleted =
    !!trimmedDisplayName &&
    trimmedDisplayName !== user.username &&
    trimmedDisplayName.toLowerCase() !== 'client';

  const avatarCompleted = hasAvatar(user);

  const locationText = user.location?.text || '';
  const locationCompleted =
    !!locationText.trim() && locationText.toLowerCase() !== 'private';

  const sectorCompleted =
    !user.organisation ||
    (Array.isArray(user.sectors) && user.sectors.length > 0);

  const steps = [nameCompleted, avatarCompleted, locationCompleted];
  if (user.organisation) {
    steps.push(sectorCompleted);
  }

  const profileStepsTotal = steps.length;
  const profileStepsCompleted = steps.filter(Boolean).length;

  const profileCompletionPercentage =
    profileStepsTotal > 0
      ? Math.round((profileStepsCompleted / profileStepsTotal) * 100)
      : 0;

  const isProfileComplete =
    profileStepsCompleted === profileStepsTotal && profileStepsTotal > 0;

  return {
    nameCompleted,
    avatarCompleted,
    locationCompleted,
    sectorCompleted,
    profileStepsCompleted,
    profileStepsTotal,
    profileCompletionPercentage,
    isProfileComplete,
  };
};
